import React from 'react';

const WhoShouldAttend = () => {
  const attendees = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      title: 'HR Leadership',
      description: 'CHROs, VPs of HR, and Chief People Officers driving strategic people initiatives and organizational transformation'
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect width="20" height="14" x="2" y="7" rx="2" ry="2"/>
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
      ),
      title: 'Business Leadership',
      description: 'C-suite executives and business heads championing culture-driven growth and AI integration strategies'
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <circle cx="12" cy="12" r="6"/>
          <circle cx="12" cy="12" r="2"/>
        </svg>
      ),
      title: 'Culture & AI Champions',
      description: 'Leaders pioneering the intersection of workplace culture, technology adoption, and human-centered innovation'
    }
  ];

  return (
    <section className="py-[60px] bg-[#F5F5F0] opacity-0 animate-fadeIn-delayed-5">
      <div className="w-[90%] max-w-[1200px] mx-auto px-5">
        <h2 className="font-heading font-semibold text-[2rem] relative pb-[15px] mb-8 text-[#333333] text-center">
          Who Should Attend
        </h2>
        <div className="max-w-[1000px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-[25px] mt-[30px]">
            {attendees.map((attendee, index) => (
              <div 
                key={index}
                className="bg-[linear-gradient(135deg,#ffffff_0%,#f9fafb_100%)] border-2 border-transparent rounded-2xl p-[30px] shadow-[0_4px_20px_rgba(0,0,0,0.06)] text-center transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_8px_25px_rgba(107,77,196,0.2)] hover:border-[#6B4DC4] group"
              >
                <div className="w-[50px] h-[50px] mx-auto mb-[15px] bg-gradient-to-br from-[#6B4DC4] to-[#4ECDC4] rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110">
                  <div className="stroke-white">
                    {attendee.icon}
                  </div>
                </div>
                <h3 className="text-[1.4rem] mb-[15px] text-[#333333] font-heading font-semibold">
                  {attendee.title}
                </h3>
                <p className="text-base text-[#666666] mb-0 leading-relaxed">
                  {attendee.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoShouldAttend;

